import { CustomTheme } from '@/ui/components/custom-theme/custom-theme'
import { NavigationTabs } from '@/ui/shared'
import { useCustomisationTabs } from './configuration-tabs'
import {
  isDashboardBlocked,
  useFeatureFlag
} from '@/application/use-feature-flag'
import { BlockedDashboardOverlay } from '@/ui/components/overlays/blocked-dashboard-overlay'

// useFeatureFlag keeps this in its effect dependencies, so an inline literal would re-evaluate
// the flag — a Flagr call — on every render.
const FLAG_CONTEXT = { pageName: 'configuration' }

function Theme() {
  const { isFlagEnabled } = useFeatureFlag(isDashboardBlocked, FLAG_CONTEXT)

  const tabs = useCustomisationTabs()

  // Full height with no page scroll: the theme editor is a stage plus an inspector that
  // scrolls on its own, like a design tool.
  return (
    <div className="flex h-full flex-col">
      <NavigationTabs tabs={tabs} selectedIndex={0} />
      {isFlagEnabled && <BlockedDashboardOverlay />}
      <div className="min-h-0 flex-1">
        <CustomTheme />
      </div>
    </div>
  )
}

export default Theme
